import GENDERBYROLE from 'data/mantechcar24/gender-comparison-by-role.json';
import { useI18n } from 'hooks/useI18n';
import React from 'react';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const GenderComparison: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');

  const genderByRole = GENDERBYROLE.sort((a, b) =>
    a.female > b.female ? -1 : 1
  );

  return (
    <div>
      <StyledRecharts className="gender gender-by-role">
        <ResponsiveContainer height={550} width="99%" minWidth={500}>
          <BarChart data={genderByRole} layout="vertical">
            <XAxis type="number" hide={true}></XAxis>
            <YAxis
              type="category"
              dataKey="role"
              tickLine={false}
              width={210}
              axisLine={false}
              tickMargin={10}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => value.toFixed(1) + '%'}
              wrapperClassName="tooltip-y"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: -5 }}
            />
            <Bar
              dataKey="female"
              stackId="a"
              name={t('mantechcar24.gender.females')}
              barSize={12}
              radius={5}
              fill="#974EA2"
            ></Bar>
            <Bar
              dataKey="male"
              stackId="a"
              name={t('mantechcar24.gender.males')}
              barSize={12}
              radius={5}
              fill="#7EAFD3"
            />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default GenderComparison;
